export default Object.freeze({
  possession: 'VLADENIE',
  house: 'DOM',
  homeOwnership: 'DOMOVLADENIE',
  building: 'ZDANIE',
});
